import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const ReassignModal = ({
	isOpen = false,
	agencyId,
	currentCoordId,
	onReassign,
	onCancel,
}) => {
	const [assignTo, setAssignTo] = useState('');
	const modalRef = useRef();
	useEffect(() => {
		if (isOpen) {
			setAssignTo('');
			modalRef.current.showModal();
		}
	}, [isOpen]);

	const assignableCoords = useQuery({
		queryKey: ['assignable-coords', agencyId],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${agencyId}/list-coords`,
			);
			return sortBy(
				data.filter(({ id }) => id !== currentCoordId),
				['name_last', 'name_first'],
			);
		},
		enabled: isOpen,
	});

	const handleReassignClick = () => {
		onReassign(assignTo);
	};

	return (
		<dialog id="reassign-dialog" className="modal" ref={modalRef}>
			<div className="modal-box">
				<h3>Reassign Service Request</h3>
				<div className="py-4 form-control">
					<label htmlFor="reassign-to" className="label">
						Reassign to
					</label>
					<select
						id="reassign-to"
						className="select select-bordered"
						value={assignTo}
						onChange={({ target }) => setAssignTo(target.value)}
						autoComplete="off"
						required
					>
						<option value=""></option>
						{assignableCoords?.data?.map((coord) => (
							<option key={`${coord.id}`} value={coord.id}>
								{coord.name_first} {coord.name_last}
							</option>
						))}
					</select>
				</div>
				<div className="modal-action">
					<form method="dialog">
						<button className="btn" onClick={onCancel}>
							Cancel
						</button>
						<button
							className="ml-4 btn btn-primary"
							onClick={handleReassignClick}
							disabled={assignTo === ''}
						>
							Reassign
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

ReassignModal.propTypes = {
	isOpen: PropTypes.bool,
	agencyId: PropTypes.number.isRequired,
	onReassign: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	currentCoordId: PropTypes.number,
};

export default ReassignModal;
